<template>
    <div class="container" dir="ltr">
        <div class="page page1">
            <img :src="require('@/assets/img/walk1.png')" alt="illustration" class="slide__image">
            <h3>گفتگو با هوش مصنوعی و فراتر از آن</h3>
            <p>به جهان هوشمند خوش آمدید!
                <br>
                برای هر سوال روزمره و در هر موضوعی که نیاز دارید، با هوش مصنوعی روبو به تمامی زبان های زنده دنیا
                بپردازید.
            </p>
            <div class="foot-box">
                <p @click="gotoLogin()">بیخیال</p>
                <div class="btn-right btn-r-1">
                    <i class="fa-solid fa-arrow-right"></i>
                </div>
            </div>
        </div>
        <div class="page page2">
            <img :src="require('@/assets/img/walk2.png')" alt="illustration" class="slide__image">
            <h3>ایده های جذابتان را به تصویر بکشید</h3>
            <p>
                ایجاد تصاویر متنوع و جذاب را با روبو پیکاسو تجربه کنید.
                <br>
                تصاویر منحصر بفرد جدید خود را در استایل های مختلف بسازید و سپس ذخیره کنید و با دوستانتان به اشتراک
                بگذارید.
            </p>

            <div class="foot-box">
                <p @click="gotoLogin()">بیخیال</p>
                <div class="btn-right btn-r-2">
                    <i class="fa-solid fa-arrow-right"></i>
                </div>
            </div>
        </div>
        <div class="page page3">
            <img :src="require('@/assets/img/walk3.png')" alt="illustration" class="slide__image">
            <h3>با شخصیت های مختلف روبو گفتگو کن</h3>
            <p>
                برای اولین بار قابلیت گفتگو با شخصیت های مختلف را با روبو تجربه کنید.
                <br>
                مانند: روان شناس, برنامه نویس, معلم, مترجم و ...
            </p>
            <div class="foot-box2">
                <button @click="gotoLogin()" class="btn-get-started">
                    <p style="margin-bottom:0">آغاز ماجراجویی</p>
                    <i class="fa-solid fa-arrow-right"></i>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
/* eslint-disable */
import router from '@/router';
export default {
    name: 'App',

    data() {
        return {
        };
    },
    methods: {
        gotoLogin() {
            router.push("/login")
        }
    },
    mounted() {

        localStorage.setItem("onboarding", "true");
        document.body.style.backgroundColor = "#212529";

        const page1 = document.querySelector(".page1");
        const page2 = document.querySelector(".page2");
        const page3 = document.querySelector(".page3");

        const btnRigth1 = document.querySelector(".btn-r-1");
        const btnRigth2 = document.querySelector(".btn-r-2");

        btnRigth1.addEventListener("click", () => {
            page1.style.display = "none";
            page2.style.display = "flex";
            page3.style.display = "none";
        })
        btnRigth2.addEventListener("click", () => {
            page1.style.display = "none";
            page2.style.display = "none";
            page3.style.display = "flex";
        })
    }

}
</script>
<style scoped>
@font-face {
    font-family: IRANSansWeb;
    src: url('../assets/IRANSansWeb.woff2') format("woff2");
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: IRANSansWeb;
    src: url('../assets/IRANSansWebBold.woff2') format("woff2");
    font-weight: bold;
    font-style: normal;
}

* {
    font-family: IRANSansWeb;
}

p {
    color: white !important;
    unicode-bidi: plaintext;
    text-align: right;
}

h3 {
    color: white !important;
}

.container {
    box-sizing: border-box;
    width: 100%;
    max-width: 450px;
    height: 100%;
    background-color: #212529;
}

.page {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 10px;
    color: #222;
    animation: opacity .7s linear;
}

iframe {
    margin-top: 5rem;
    border: none;
}

.page>h3 {
    font-size: 22px;
    margin-top: 5rem;
    font-weight: bold;

}

.page>p {
    font-size: 16px;
    margin-top: 1.5rem;
    width: 80%;
}

@media(min-width:768px) {
    .page>.foot-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 30vw;
        position: absolute;
        bottom: 2.5rem;
    }

    .page>.foot-box2 {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30vw;
        position: absolute;
        bottom: 2.5rem;
    }
}

@media(max-width:767px) {
    .page>.foot-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 85%;
        position: absolute;
        bottom: 2.5rem;
    }

    .page>.foot-box2 {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 85%;
        position: absolute;
        bottom: 2.5rem;
    }
}

.page>.foot-box>p {
    color: #9597a4;
    cursor: pointer;
    margin-top: 15px;
}

.page>.foot-box>.btn-right {
    width: 42px;
    aspect-ratio: 1;
    background-color: #6153cc;
    color: #fff;
    display: grid;
    place-items: center;
    font-size: 18px;
    border-radius: 0 0 12px 0;
    position: relative;
    cursor: pointer;
    z-index: 1;
}

.page>.foot-box>.btn-right:hover:before {
    content: "";
    position: absolute;
    right: -8px;
    bottom: -8px;
    background-color: #ff996256;
    width: 42px;
    aspect-ratio: 1;
    z-index: -1;
    border-radius: 0 0 12px 0;
    animation: appeare .4s linear;
}

.page3>.foot-box2>.btn-get-started {
    padding: 10px 20px;
    width: 182px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    font-size: 17px;
    gap: 10px;
    border: none;
    background-color: #6153cc;
    font-family: IRANSansWeb;
    border-radius: 0 0 12px 0;
    position: relative;
    cursor: pointer;
    z-index: 1;
}

.page3>.btn-get-started:hover:before {
    content: "";
    position: absolute;
    right: -8px;
    bottom: -8px;
    background-color: #ff996256;
    width: 182px;
    height: 100%;
    z-index: -1;
    border-radius: 0 0 12px 0;
    animation: appeare .4s linear;
}

.pageFinal {
    margin-top: 2rem;
    padding: 50px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    justify-content: center;
    align-items: center;
    position: relative;
    animation: opacity .7s linear;
}

.pageFinal>h3 {
    color: #222;
    text-align: center;
}

.pageFinal>button {
    font-family: IRANSansWeb;
    width: 30%;
    padding: 5px 15px;
    margin-top: 1rem;
    border: none;
    cursor: pointer;
    background-color: #6153cc;
    font-size: 17px;
    color: #fff;
    border-radius: 0 0 12px 0;
    position: relative;
    z-index: 1;
}

.pageFinal>button:hover:before {
    content: "";
    position: absolute;
    right: -8px;
    bottom: -8px;
    background-color: #ff996256;
    width: 82.5px;
    height: 100%;
    border-radius: 0 0 12px 0;
    z-index: -1;
    animation: appeare .4s linear;
}

@keyframes appeare {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes opacity {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.page1 {
    display: flex;
}

.page2 {
    display: none;
}

.page3 {
    display: none;
}

.pageFinal {
    display: none;
}
</style>